(function () {
  'use strict';

  var FADE_MS = 320;

  function initImageLightbox() {
    var overlay = document.querySelector('[data-image-lightbox]');
    if (!overlay) return;

    var img = overlay.querySelector('[data-lightbox-image]');
    var closeBtn = overlay.querySelector('[data-lightbox-close]');
    if (!img) return;

    var isOpen = false;
    var closeTimer = null;

    function open(src, alt) {
      if (!src || isOpen) return;

      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }

      img.src = src;
      img.alt = alt || '';
      overlay.hidden = false;
      document.body.classList.add('is-image-lightbox-open');

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          overlay.classList.add('is-active');
          isOpen = true;
        });
      });
    }

    function close() {
      if (!isOpen) return;

      overlay.classList.remove('is-active');
      isOpen = false;
      document.body.classList.remove('is-image-lightbox-open');

      closeTimer = setTimeout(function () {
        overlay.hidden = true;
        img.removeAttribute('src');
        img.alt = '';
        closeTimer = null;
      }, FADE_MS);
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lightbox-src]');
      if (!trigger || trigger.closest('[data-image-lightbox]')) return;
      e.preventDefault();
      open(
        trigger.getAttribute('data-lightbox-src') || trigger.currentSrc || trigger.src,
        trigger.getAttribute('data-lightbox-alt') || trigger.getAttribute('alt') || ''
      );
    });

    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('image-lightbox__stage')) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initImageLightbox);
  } else {
    initImageLightbox();
  }
})();
